{
  "actual_edges": [
    {
      "from": "w1",
      "id": "w1-to-w2",
      "kind": "actual",
      "to": "w2"
    },
    {
      "from": "w2",
      "id": "w2-to-w3",
      "kind": "actual",
      "to": "w3"
    },
    {
      "from": "w3",
      "id": "w3-to-w4",
      "kind": "actual",
      "to": "w4"
    },
    {
      "from": "w4",
      "id": "w4-to-w5",
      "kind": "actual",
      "to": "w5"
    },
    {
      "from": "w5",
      "id": "w5-to-w6",
      "kind": "actual",
      "to": "w6"
    },
    {
      "from": "w6",
      "id": "w6-to-w7",
      "kind": "actual",
      "to": "w7"
    },
    {
      "from": "w7",
      "id": "w7-to-w8",
      "kind": "actual",
      "to": "w8"
    },
    {
      "from": "w8",
      "id": "w8-to-w9",
      "kind": "actual",
      "to": "w9"
    },
    {
      "from": "w9",
      "id": "w9-to-w10",
      "kind": "actual",
      "to": "w10"
    },
    {
      "from": "w10",
      "id": "w10-to-w11",
      "kind": "actual",
      "to": "w11"
    },
    {
      "from": "w11",
      "id": "w11-to-w12",
      "kind": "actual",
      "to": "w12"
    },
    {
      "from": "w12",
      "id": "w12-to-w13",
      "kind": "actual",
      "to": "w13"
    },
    {
      "from": "w13",
      "id": "w13-to-w14",
      "kind": "actual",
      "to": "w14"
    },
    {
      "from": "w14",
      "id": "w14-to-w15",
      "kind": "actual",
      "to": "w15"
    },
    {
      "from": "w15",
      "id": "w15-to-w16",
      "kind": "actual",
      "to": "w16"
    },
    {
      "from": "w16",
      "id": "w16-to-w17",
      "kind": "actual",
      "to": "w17"
    },
    {
      "from": "w17",
      "id": "w17-to-w18",
      "kind": "actual",
      "to": "w18"
    },
    {
      "from": "w18",
      "id": "w18-to-w19",
      "kind": "actual",
      "to": "w19"
    }
  ],
  "agent_commit": "c96f2ed3595162a174e680b563337f6215f6eace",
  "branch_semantics": {
    "available_actions": "legal-actions-not-future-state-branches",
    "event_choices": "legal-options-not-executed-unless-selected",
    "projected_counterfactual_states": false
  },
  "campaign_id": "playthrough-evidence-full-v1",
  "cell_id": "study-seed-42-f9980b3d5bc8",
  "completed_weeks": 19,
  "difficulty": "normal",
  "final_ending": "cashflow_collapse",
  "game_commit": "348b9fd5501e71ebc7142e10f9068fc1490b5124",
  "game_tree": "225cd5451d09bb92da674234a79ecaf8db4beb3a",
  "nodes": [
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_school_germany",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "student_club",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 12,
        "energy": -36,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 19,
        "money": -303,
        "social": 5,
        "stress": 11
      },
      "event": {
        "id": "arrival",
        "legal_choices": [
          {
            "choice_id": "arrival.choice_01_先去宿舍放行李",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "energy": 10.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "先去宿舍放行李"
          },
          {
            "choice_id": "arrival.choice_02_立刻去超市和_dm_补生活用品",
            "failure_effects": {
              "energy": -6.0,
              "hunger": 6.0,
              "money": -55.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived_supplied",
            "success_effects": {
              "energy": -6.0,
              "hunger": -10.0,
              "money": -55.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "立刻去超市和 dm 补生活用品"
          },
          {
            "choice_id": "arrival.choice_03_先激活_sim_卡和银行_app",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "arrived",
            "success_effects": {
              "language": 1.0,
              "stress": 4.0,
              "visa_progress": 4.0
            },
            "success_rate": 0.746,
            "text": "先激活 SIM 卡和银行 App"
          },
          {
            "choice_id": "arrival.choice_04_坐在车站缓一缓",
            "failure_effects": {
              "money": -25.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "loneliness": 4.0,
              "money": -25.0,
              "stress": -8.0,
              "visa_progress": -2.0
            },
            "success_rate": 1.0,
            "text": "坐在车站缓一缓"
          }
        ],
        "selected_choice_id": "arrival.choice_01_先去宿舍放行李"
      },
      "evidence": {
        "decision_request_fingerprint": "96667c0dceeda55f17fbd08ad2e030c63e85eb3000659affa77f214653178777",
        "event_request_fingerprint": "2b9ef5c326662590d4b29bc66829326bdad7fb6c62f86f564da8f7e5546aea9a",
        "source_line": 1,
        "source_record_sha256": "9eb876a4c0f46e90f143a2f1af692bc9a0548cb3f6138fabf9a862cae6a9b07a"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 12,
        "blocked_account_balance": -992,
        "energy": -36,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 19,
        "money": -303,
        "social": 5,
        "stress": 11,
        "unpaid_social_streak": 2,
        "week": 1
      },
      "id": "w1",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 2,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 4 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 84,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          },
          {
            "body": "当前可支配现金 197 EUR，逾期 0 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 58,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "language_school_germany",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 64,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 37,
        "language": 39,
        "loneliness": 30,
        "money": 197,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 31,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 15,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 10,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 11904,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 100,
        "exam_readiness": 11,
        "failed_courses": 0,
        "flags": {},
        "gpa_score": 61,
        "hunger": 25,
        "language": 20,
        "loneliness": 30,
        "money": 500,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 15,
        "stress": 20,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 0,
        "visa_progress": 15,
        "week": 1,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 1
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 2,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 10,
        "energy": -32,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 14,
        "loneliness": 2,
        "money": -157,
        "social": 3,
        "stress": 14,
        "visa_progress": 2
      },
      "event": {
        "id": "germany_language_track_start",
        "legal_choices": [
          {
            "choice_id": "germany_language_track_start.choice_01_报名密集语言班",
            "failure_effects": {
              "language": -1.0,
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "language": 10.0,
              "money": -420.0,
              "stress": 6.0
            },
            "success_rate": 1.0,
            "text": "报名密集语言班"
          },
          {
            "choice_id": "germany_language_track_start.choice_02_先自学一周省钱",
            "failure_effects": {
              "language": -1.0,
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -4.0,
              "language": 4.0,
              "money": 40.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "先自学一周省钱"
          },
          {
            "choice_id": "germany_language_track_start.choice_03_问学校能否条件注册",
            "failure_effects": {
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.509,
            "text": "问学校能否条件注册"
          },
          {
            "choice_id": "germany_language_track_start.choice_04_找便宜语言学校",
            "failure_effects": {
              "language": 2.0,
              "money": -220.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 6.0,
              "money": -260.0,
              "stress": 8.0
            },
            "success_rate": 0.609,
            "text": "找便宜语言学校"
          }
        ],
        "selected_choice_id": "germany_language_track_start.choice_02_先自学一周省钱"
      },
      "evidence": {
        "decision_request_fingerprint": "f7922d60abcab26e5c553e4b2a32608c3800771c1430ce029a445905e6cb7749",
        "event_request_fingerprint": "a96685602a51257a3708397fd1b74be847b998dc742a1718b02ac3ccd6c10a49",
        "source_line": 2,
        "source_record_sha256": "b0acb6e3a7dcd9109f0e48dc1c406d0dd91c20145755f092ec7564621213e93f"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 10,
        "arrears_amount": 58,
        "cash_shortfall_count": 1,
        "energy": -32,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 14,
        "loneliness": 2,
        "money": -157,
        "social": 3,
        "stress": 14,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w2",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 3,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 3 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 91,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前可支配现金 40 EUR，逾期 58 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 78,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 32,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 58,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 1,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 49,
        "language": 53,
        "loneliness": 32,
        "money": 40,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 45,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 17,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 64,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 37,
        "language": 39,
        "loneliness": 30,
        "money": 197,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 31,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 15,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 2
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 3,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 8,
        "exam_readiness": 17,
        "hunger": 29,
        "language": 10,
        "loneliness": 3,
        "money": -40,
        "social": 1,
        "stress": 20,
        "visa_progress": 2
      },
      "event": {
        "id": "missing_school_registration",
        "legal_choices": [
          {
            "choice_id": "missing_school_registration.choice_02_先找_international_office",
            "failure_effects": {
              "academic_progress": -7.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "school_registered",
            "success_effects": {
              "academic_progress": -3.0,
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.893,
            "text": "先找 International Office"
          },
          {
            "choice_id": "missing_school_registration.choice_03_只靠自学顶一周",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -6.0,
              "hunger": 5.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "只靠自学顶一周"
          },
          {
            "choice_id": "missing_school_registration.choice_04_继续拖延",
            "failure_effects": {
              "money": -80.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -10.0,
              "money": -80.0,
              "stress": 8.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "missing_school_registration.choice_03_只靠自学顶一周"
      },
      "evidence": {
        "decision_request_fingerprint": "021c31a652208e62706bb32f4357accefe27c8fc43b195b5972fc40dcec4e73b",
        "event_request_fingerprint": "22dda20a86192b36cc7cf74b0eee03469b68a27789aa29cdc68c17661142471f",
        "source_line": 3,
        "source_record_sha256": "b56a165e185dc207b323abe25aada4a27914ae8903c9aab3555760a8fd1bfab7"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 8,
        "arrears_amount": 215,
        "cash_shortfall_count": 1,
        "exam_readiness": 17,
        "hunger": 29,
        "language": 10,
        "loneliness": 3,
        "money": -40,
        "social": 1,
        "stress": 20,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w3",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 4,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 2 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 98,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 82,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 273 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 78,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 40,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 273,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 78,
        "language": 63,
        "loneliness": 35,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 65,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 19,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 32,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 58,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 1,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 49,
        "language": 53,
        "loneliness": 32,
        "money": 40,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 45,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 17,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 3
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 4,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 4,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [
        "burnout-risk"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 12,
        "energy": -16,
        "exam_readiness": 17,
        "hunger": 22,
        "language": 10,
        "loneliness": 3,
        "social": 4,
        "stress": 30,
        "visa_progress": 8
      },
      "event": {
        "id": "wg_interview",
        "legal_choices": [
          {
            "choice_id": "wg_interview.choice_01_表现得非常德式",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "housing_stable",
            "success_effects": {
              "social": 3.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.725,
            "text": "表现得非常德式"
          },
          {
            "choice_id": "wg_interview.choice_02_说自己会做中餐",
            "failure_effects": {
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "wg_cooking",
            "success_effects": {
              "hunger": -6.0,
              "loneliness": -4.0,
              "social": 7.0
            },
            "success_rate": 0.622,
            "text": "说自己会做中餐"
          },
          {
            "choice_id": "wg_interview.choice_03_坦白预算很紧",
            "failure_effects": {
              "social": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "cheap_room_hint",
            "success_effects": {
              "money": 120.0,
              "stress": 5.0
            },
            "success_rate": 0.281,
            "text": "坦白预算很紧"
          },
          {
            "choice_id": "wg_interview.choice_04_过度迎合每条规则",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002
            },
            "set_flag": "housing_stable",
            "success_effects": {
              "energy": -6.0,
              "social": 2.0,
              "stress": 8.0
            },
            "success_rate": 0.426,
            "text": "过度迎合每条规则"
          }
        ],
        "selected_choice_id": "wg_interview.choice_01_表现得非常德式"
      },
      "evidence": {
        "decision_request_fingerprint": "94ae4ea1fa4a780f4aa62d561cabad70b1ad1b35a99bd56e3f81ade90e360d49",
        "event_request_fingerprint": "e6f5b2cafbed5756979754503a86861d6859ad1c3b0119b3467efc32dc747b9a",
        "source_line": 4,
        "source_record_sha256": "6d4bbdd9ea2dada87127db9d24aad39a35e112803c93c5cdfcccc9e0b02b5528"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 12,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -16,
        "exam_readiness": 17,
        "hunger": 22,
        "language": 10,
        "loneliness": 3,
        "social": 4,
        "stress": 30,
        "unpaid_social_streak": 2,
        "visa_progress": 8,
        "week": 1
      },
      "id": "w4",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 5,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 1 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 528 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 52,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 528,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 73,
        "loneliness": 38,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 95,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 27,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 40,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 273,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 78,
        "language": 63,
        "loneliness": 35,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 65,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 19,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 4
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 5,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 5,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": 17,
        "language": 10,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": 5,
        "visa_progress": 5
      },
      "event": {
        "id": "legal_work_limit_notice",
        "legal_choices": [
          {
            "choice_id": "legal_work_limit_notice.choice_01_把工时记进日历",
            "failure_effects": {
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": 2.0,
              "visa_progress": 3.0
            },
            "success_rate": 1.0,
            "text": "把工时记进日历"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_02_只接合同清楚的班",
            "failure_effects": {
              "career_progress": -1.0,
              "money": -40.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "career_progress": 3.0,
              "money": -40.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接合同清楚的班"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_03_问_asta/international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "language": 2.0,
              "stress": -1.0,
              "visa_progress": 4.0
            },
            "success_rate": 1.0,
            "text": "问 AStA/International Office"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_04_觉得自己不会超",
            "failure_effects": {
              "stress": 4.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": -2.0
            },
            "success_rate": 0.316,
            "text": "觉得自己不会超"
          }
        ],
        "selected_choice_id": "legal_work_limit_notice.choice_01_把工时记进日历"
      },
      "evidence": {
        "decision_request_fingerprint": "0ba2c01ed88371b11f50d025eac928c41b8b6ee0aa139e99289ea0ec017d5c8f",
        "event_request_fingerprint": "f008bc770696f5feeb3139c64a961c3de6250c9c042ca7ebacdb3e8ea7e47d7d",
        "source_line": 5,
        "source_record_sha256": "849332f93ea530bd8025f92a265840a0a04270c56ff14e5c7060d0951395534f"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "exam_readiness": 17,
        "language": 10,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": 5,
        "unpaid_social_streak": 2,
        "visa_progress": 5,
        "week": 1
      },
      "id": "w5",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 6,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 0 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 59,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 528,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 83,
        "loneliness": 41,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 32,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 52,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 528,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 73,
        "loneliness": 38,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 95,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 27,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 5
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 6,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 6,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [
        "cashflow-stress-attractor"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -117,
        "social": 4,
        "visa_progress": 8
      },
      "event": {
        "id": "anmeldung_deadline",
        "legal_choices": [
          {
            "choice_id": "anmeldung_deadline.choice_01_立刻补材料",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": -4.0,
              "stress": 4.0,
              "visa_progress": 7.0
            },
            "success_rate": 1.0,
            "text": "立刻补材料"
          },
          {
            "choice_id": "anmeldung_deadline.choice_02_先问_international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 1.0,
              "stress": -2.0,
              "visa_progress": 5.0
            },
            "success_rate": 1.0,
            "text": "先问 International Office"
          },
          {
            "choice_id": "anmeldung_deadline.choice_03_请室友确认_wohnungsgeberbestätigung",
            "failure_effects": {
              "stress": 6.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "social": 3.0,
              "stress": 1.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.845,
            "text": "请室友确认 Wohnungsgeberbestätigung"
          },
          {
            "choice_id": "anmeldung_deadline.choice_04_把信封塞进抽屉",
            "failure_effects": {
              "money": -30.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "admin_avoidance",
            "success_effects": {
              "money": -30.0,
              "stress": -5.0,
              "visa_progress": -8.0
            },
            "success_rate": 1.0,
            "text": "把信封塞进抽屉"
          }
        ],
        "selected_choice_id": "anmeldung_deadline.choice_03_请室友确认_wohnungsgeberbestätigung"
      },
      "evidence": {
        "decision_request_fingerprint": "d7fabad18538c4b0cdd53cc6052481cd6ef7ac826b001bd72506eca129095c2c",
        "event_request_fingerprint": "eeb7163fd64d9ef8ace455891c14eab70af7dd9f4db36889e0065244c9b5cc82",
        "source_line": 6,
        "source_record_sha256": "96dd8f16213e62fe36ce795af394f2e04580bec5d0b7e670a992e932c4b50922"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -117,
        "social": 4,
        "unpaid_social_streak": 2,
        "visa_progress": 8,
        "week": 1
      },
      "id": "w6",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 7,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 666 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 66,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 666,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 93,
        "loneliness": 44,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 33,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 40,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 59,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 528,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 83,
        "loneliness": 41,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 32,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 6
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 7,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 7,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": -2,
        "language": 7,
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "registration_window_missed",
        "legal_choices": [
          {
            "choice_id": "registration_window_missed.choice_01_接受下学期再注册",
            "failure_effects": {
              "money": -650.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -12.0,
              "money": -650.0,
              "stress": 14.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "接受下学期再注册"
          },
          {
            "choice_id": "registration_window_missed.choice_03_转入语言班等待下学期",
            "failure_effects": {
              "language": -1.0,
              "money": -900.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -9.0,
              "language": 8.0,
              "money": -900.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "转入语言班等待下学期"
          },
          {
            "choice_id": "registration_window_missed.choice_04_逃避邮件和截止日",
            "failure_effects": {
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -16.0,
              "hunger": 8.0,
              "money": -420.0,
              "stress": 22.0
            },
            "success_rate": 1.0,
            "text": "逃避邮件和截止日"
          }
        ],
        "selected_choice_id": "registration_window_missed.choice_03_转入语言班等待下学期"
      },
      "evidence": {
        "decision_request_fingerprint": "fb068f3d58c13f13510a23a57056abb02021735935081dea47d70d3924943898",
        "event_request_fingerprint": "e41269b546a107b3d3f7bf0d9c773f2a1cea4f7d5e62ac53d616ec1f3d3c64be",
        "source_line": 7,
        "source_record_sha256": "bca6b595914ec9f1615fae3125d740b540acda756f8f9a1e543707e21453e56f"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -2,
        "arrears_amount": 1155,
        "cash_shortfall_count": 2,
        "language": 7,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w7",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 8,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 1821 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 64,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1821,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 6,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 42,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 66,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 666,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 93,
        "loneliness": 44,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 33,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 40,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 7
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 7,
        "loneliness": 3,
        "money": 35,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "parents_money_hint",
        "legal_choices": [
          {
            "choice_id": "parents_money_hint.choice_01_做预算表给他们看",
            "failure_effects": {
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 120.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "做预算表给他们看"
          },
          {
            "choice_id": "parents_money_hint.choice_02_先安慰他们",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "先安慰他们"
          },
          {
            "choice_id": "parents_money_hint.choice_03_稳妥处理",
            "failure_effects": {
              "money": 35.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 105.0,
              "stress": 1.0
            },
            "success_rate": 0.412,
            "text": "稳妥处理"
          },
          {
            "choice_id": "parents_money_hint.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 70.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.636,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "parents_money_hint.choice_03_稳妥处理"
      },
      "evidence": {
        "decision_request_fingerprint": "96891b05833686f443f9dbdea42392cabe018705c1da20ab1daed09d721c63b8",
        "event_request_fingerprint": "cc017d3782b1558cfc9858417fb18dea53e3806236b3f72b764ea41c59a66a9e",
        "source_line": 8,
        "source_record_sha256": "d9f9ed658890803685022d809a98416187f29c949723750117f1ec5e957abfe8"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "money": 35,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w8",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 9,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 35 EUR，逾期 2076 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 71,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2076,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 7,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 50,
        "money": 35,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 35,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 44,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 64,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1821,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 6,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 42,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 8
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 9
            },
            "streak_weeks": 6,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 6 consecutive weeks (week=9).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 9
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_registration",
        "legal_choices": [
          {
            "choice_id": "exam_registration.choice_01_马上报名",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 2.0,
              "exam_readiness": 4.0,
              "stress": -3.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "马上报名"
          },
          {
            "choice_id": "exam_registration.choice_02_报名后顺手查考纲",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 1.0,
              "exam_readiness": 7.0,
              "stress": 1.0
            },
            "success_rate": 1.0,
            "text": "报名后顺手查考纲"
          },
          {
            "choice_id": "exam_registration.choice_03_先问同学报名流程",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "exam_registered",
            "success_effects": {
              "exam_readiness": 3.0,
              "social": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.644,
            "text": "先问同学报名流程"
          },
          {
            "choice_id": "exam_registration.choice_04_晚点再说",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -4.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "晚点再说"
          }
        ],
        "selected_choice_id": "exam_registration.choice_04_晚点再说"
      },
      "evidence": {
        "decision_request_fingerprint": "691673c20f204fcaa7341a1edb5e9e4f894e13ddcfdaa0e96862786c56afd888",
        "event_request_fingerprint": "e8c3a780a6b308a6116ccd7030f7ff37d6dbcd69b26a9d738bfb7a8649b11f5b",
        "source_line": 9,
        "source_record_sha256": "cc4ba4eab0da5d26e5dce75c6d741725fe262c692bf3dd1372c3b317eecf93fe"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "exam_readiness": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w9",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 10,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 152 EUR，逾期 2076 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 78,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2076,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 7,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 53,
        "money": 152,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 36,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 46,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 71,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2076,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 7,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 50,
        "money": 35,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 35,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 44,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 9
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "midterm_pressure",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 10
            },
            "streak_weeks": 7,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 7 consecutive weeks (week=10).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 10
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "therapy",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 14,
        "exam_readiness": 4,
        "loneliness": 3,
        "money": -152,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "midterm_pressure",
        "legal_choices": [
          {
            "choice_id": "midterm_pressure.choice_01_整理学习计划",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 5.0,
              "exam_readiness": 4.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "整理学习计划"
          },
          {
            "choice_id": "midterm_pressure.choice_02_先睡一觉",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -2.0,
              "energy": 16.0,
              "exam_readiness": -2.0,
              "stress": -6.0
            },
            "success_rate": 1.0,
            "text": "先睡一觉"
          },
          {
            "choice_id": "midterm_pressure.choice_03_砍掉一班打工补作业",
            "failure_effects": {
              "academic_progress": -1.0,
              "money": -139.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 7.0,
              "exam_readiness": 5.0,
              "money": -139.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "砍掉一班打工补作业"
          },
          {
            "choice_id": "midterm_pressure.choice_04_靠咖啡硬顶",
            "failure_effects": {
              "academic_progress": -1.0,
              "energy": -12.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 4.0,
              "energy": -12.0,
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "靠咖啡硬顶"
          }
        ],
        "selected_choice_id": "midterm_pressure.choice_03_砍掉一班打工补作业"
      },
      "evidence": {
        "decision_request_fingerprint": "fe133edb8eef4fe32c9951cc2ceeac43e3499d8e9a79c5913d4ca7f33b80fb4d",
        "event_request_fingerprint": "4e6500e6bdf0cdb87f26fee57873dd23bebbcd05b30e10259a171ea66258b94c",
        "source_line": 10,
        "source_record_sha256": "6d38c4d2720936d9be7a659583f5b00dfd7233b4f11103725ae714bf473f80a2"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 14,
        "arrears_amount": 242,
        "cash_shortfall_count": 2,
        "exam_readiness": 4,
        "loneliness": 3,
        "money": -152,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w10",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 11,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2318 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 92,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2318,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 56,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 37,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 48,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 78,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2076,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 7,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 53,
        "money": 152,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 36,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 46,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 10
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wechat_silence",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 11
            },
            "streak_weeks": 8,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 8 consecutive weeks (week=11).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 11
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 1,
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "wechat_silence",
        "legal_choices": [
          {
            "choice_id": "wechat_silence.choice_01_写一段真实记录",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -5.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "写一段真实记录"
          },
          {
            "choice_id": "wechat_silence.choice_02_继续潜水",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 2.0,
              "loneliness": 3.0
            },
            "success_rate": 1.0,
            "text": "继续潜水"
          },
          {
            "choice_id": "wechat_silence.choice_03_稳妥处理",
            "failure_effects": {
              "energy": 0.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "stress": -2.0
            },
            "success_rate": 0.196,
            "text": "稳妥处理"
          },
          {
            "choice_id": "wechat_silence.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "social": 2.0,
              "stress": -4.0
            },
            "success_rate": 0.417,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "wechat_silence.choice_03_稳妥处理"
      },
      "evidence": {
        "decision_request_fingerprint": "d53aedeb69892057b7f1fc776e1b63bc9d7b9c798da02e4e0eca8a93398c4795",
        "event_request_fingerprint": "57c14a4764ed86538e3546387532bb589cc9d9c3ed368390636c1977675641ea",
        "source_line": 11,
        "source_record_sha256": "e4077b91eee340fedec3e680a285cfdf765d4babd7d64a0c268971b32540dd67"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 1,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w11",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 12,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2573 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2573,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 10,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 59,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 50,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 92,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2318,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 56,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 37,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 48,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 11
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "group_invite",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 12
            },
            "streak_weeks": 9,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 9 consecutive weeks (week=12).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 12
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "group_invite",
        "legal_choices": [
          {
            "choice_id": "group_invite.choice_01_答应并主动分工",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 6.0,
              "exam_readiness": 4.0,
              "language": 3.0,
              "social": 8.0
            },
            "success_rate": 0.9,
            "text": "答应并主动分工"
          },
          {
            "choice_id": "group_invite.choice_02_只接资料整理的部分",
            "failure_effects": {
              "academic_progress": -1.0,
              "social": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 4.0,
              "exam_readiness": 2.0,
              "social": 3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接资料整理的部分"
          },
          {
            "choice_id": "group_invite.choice_03_请她先解释评分标准",
            "failure_effects": {
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003,
              "social": 0.002
            },
            "set_flag": "anna_group",
            "success_effects": {
              "exam_readiness": 6.0,
              "language": 3.0,
              "social": 5.0
            },
            "success_rate": 0.853,
            "text": "请她先解释评分标准"
          },
          {
            "choice_id": "group_invite.choice_04_委婉拒绝",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "social": -4.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "委婉拒绝"
          }
        ],
        "selected_choice_id": "group_invite.choice_01_答应并主动分工"
      },
      "evidence": {
        "decision_request_fingerprint": "7375288b65db1c81bfd0e1d682b157cd5cfe5df856815e6fe081aeb8edea5263",
        "event_request_fingerprint": "0fa3c9c0f09bb01f43f66b435bb14e90c27b6046c72cda2017601c7121949829",
        "source_line": 12,
        "source_record_sha256": "5bb293a65b22e3ea73caaa9f9521f32a9ffafe72c1bd5c1e4b68b92c5172bff8"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w12",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 13,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2828 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2828,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 62,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 52,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2573,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 10,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 59,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 50,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 12
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exercise_sheet_warning",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 13
            },
            "streak_weeks": 10,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 10 consecutive weeks (week=13).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 13
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": -3,
        "exam_readiness": -8,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": -2,
        "visa_progress": 2
      },
      "event": {
        "id": "exercise_sheet_warning",
        "legal_choices": [
          {
            "choice_id": "exercise_sheet_warning.choice_01_补三套练习题",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 10.0,
              "stress": 6.0
            },
            "success_rate": 0.775,
            "text": "补三套练习题"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_02_去_tutorium_问清楚",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "language": 2.0,
              "stress": 3.0
            },
            "success_rate": 0.756,
            "text": "去 Tutorium 问清楚"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_03_和同学对答案",
            "failure_effects": {
              "exam_readiness": -2.0,
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 6.0,
              "social": 4.0,
              "stress": 2.0
            },
            "success_rate": 0.516,
            "text": "和同学对答案"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_04_先忙别的",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "exam_readiness": -8.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "先忙别的"
          }
        ],
        "selected_choice_id": "exercise_sheet_warning.choice_04_先忙别的"
      },
      "evidence": {
        "decision_request_fingerprint": "9d259d2ac61a69d899569a9aac15d9d3ff64191028a0e2fac33bd44f1b3c4056",
        "event_request_fingerprint": "6e06011d0ac799f6a451306e2b8924657df78ce69693d1679442407f9f68cf54",
        "source_line": 13,
        "source_record_sha256": "8915ff85c2940267191a989623002fefdf28ba9e5eedbde869c240db4a41420b"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -3,
        "blocked_account_balance": -992,
        "exam_readiness": -8,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": -2,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w13",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 14,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "压力 98。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 98,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 2828 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 90,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2828,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 92,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 65,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 54,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2828,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 62,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 52,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 13
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 11,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 11 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 3,
        "exam_readiness": 8,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "stress": 2,
        "visa_progress": 9
      },
      "event": {
        "id": "visa_status_hidden_check",
        "legal_choices": [
          {
            "choice_id": "visa_status_hidden_check.choice_01_立刻联系外管局和学校",
            "failure_effects": {
              "stress": 14.0,
              "visa_progress": -3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "language": 2.0,
              "stress": 9.0,
              "visa_progress": 9.0
            },
            "success_rate": 0.756,
            "text": "立刻联系外管局和学校"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "stress": 7.0,
              "visa_progress": 7.0
            },
            "success_rate": 0.676,
            "text": "补材料并申请 Fiktionsbescheinigung"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_03_只在网页上继续刷_termin",
            "failure_effects": {
              "stress": 16.0,
              "visa_progress": -4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": 10.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.436,
            "text": "只在网页上继续刷 Termin"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_04_相信不会查到自己",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": -2.0,
              "visa_progress": -8.0
            },
            "success_rate": 0.366,
            "text": "相信不会查到自己"
          }
        ],
        "selected_choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung"
      },
      "evidence": {
        "decision_request_fingerprint": "1f391f176be4c39515ca4ae4611df6b949e812abcb4fad46037958d4be711ef3",
        "event_request_fingerprint": "decf9cc0aed4ab129eb150d9b41f992fd9a5b92fa19e568bf8f4db595bce1258",
        "source_line": 14,
        "source_record_sha256": "3c11bec4ea7a070d853910ee42c43c7dbd08a42c674b4aebcfafe68fb9ad1ad5"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 3,
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "exam_readiness": 8,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "stress": 2,
        "unpaid_social_streak": 2,
        "visa_progress": 9,
        "week": 1
      },
      "id": "w14",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 15,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2966 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2966,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 68,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 63,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 90,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2828,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 92,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 65,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 54,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 14
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 0,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 0 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "hunger": -34,
        "loneliness": 3,
        "money": 20,
        "visa_progress": 2
      },
      "event": {
        "id": "desperate_illegal_work_offer",
        "legal_choices": [
          {
            "choice_id": "desperate_illegal_work_offer.choice_01_找学生会紧急援助",
            "failure_effects": {
              "hunger": -8.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -18.0,
              "money": 120.0,
              "social": 2.0,
              "stress": 6.0
            },
            "success_rate": 0.478,
            "text": "找学生会紧急援助"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_03_向同学或父母借钱",
            "failure_effects": {
              "loneliness": 5.0,
              "stress": 16.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -12.0,
              "loneliness": -3.0,
              "money": 260.0,
              "stress": 9.0
            },
            "success_rate": 0.464,
            "text": "向同学或父母借钱"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_04_接下现金黑工",
            "failure_effects": {
              "energy": -25.0,
              "illegal_work_hours": 14.0,
              "stress": 24.0,
              "visa_progress": -8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "illegal_work_taken",
            "success_effects": {
              "academic_progress": -9.0,
              "energy": -34.0,
              "hunger": -18.0,
              "illegal_work_hours": 36.0,
              "stress": 20.0
            },
            "success_rate": 0.591,
            "text": "接下现金黑工"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_05_去食物救助/低价食堂",
            "failure_effects": {
              "hunger": -18.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -34.0,
              "money": 20.0,
              "social": -1.0,
              "stress": 8.0
            },
            "success_rate": 0.638,
            "text": "去食物救助/低价食堂"
          }
        ],
        "selected_choice_id": "desperate_illegal_work_offer.choice_05_去食物救助/低价食堂"
      },
      "evidence": {
        "decision_request_fingerprint": "11c7bd5b0afbda5df5e3d357d703cc6757252c8127669704ade1ca4f73526dd1",
        "event_request_fingerprint": "dade27da2203b91848e15b466a75c6a51ece792bd60ba3385bc42c462d3a5fcf",
        "source_line": 15,
        "source_record_sha256": "1cc11a09dce47be79437f55759307b7fea2af12ed84ad8e2cd23e17fd1c84d8d"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "hunger": -34,
        "loneliness": 3,
        "money": 20,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w15",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 16,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 20 EUR，逾期 3221 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "正常注册窗口已错过，只能准备下学期注册并控制生活成本。",
            "id": "registration_delayed",
            "score": 82,
            "suggested_actions": [
              "next_semester_registration",
              "international_office"
            ],
            "title": "注册已延期"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3221,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 66,
        "language": 100,
        "loneliness": 71,
        "money": 20,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 65,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2966,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 68,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 63,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 15
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 66.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "to": 100.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 66.0 to 100 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 1,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 1 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 5,
        "energy": 8,
        "hunger": 34,
        "loneliness": 3,
        "money": -20,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "klausur_countdown",
        "legal_choices": [
          {
            "choice_id": "klausur_countdown.choice_01_整理错题清单",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 12.0,
              "stress": 5.0
            },
            "success_rate": 0.474,
            "text": "整理错题清单"
          },
          {
            "choice_id": "klausur_countdown.choice_02_约教授/助教答疑",
            "failure_effects": {
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003,
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 8.0,
              "stress": 3.0
            },
            "success_rate": 0.678,
            "text": "约教授/助教答疑"
          },
          {
            "choice_id": "klausur_countdown.choice_03_和小组模拟考试",
            "failure_effects": {
              "exam_readiness": 1.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 9.0,
              "social": 4.0,
              "stress": 4.0
            },
            "success_rate": 0.55,
            "text": "和小组模拟考试"
          },
          {
            "choice_id": "klausur_countdown.choice_04_继续拖延",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 5.0,
              "exam_readiness": -12.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "klausur_countdown.choice_01_整理错题清单"
      },
      "evidence": {
        "decision_request_fingerprint": "072a23226a3153f36b1a197a395b082f7381b3174525cec5e3d96d2030f21a78",
        "event_request_fingerprint": "cd05566a30970b41263adedc0d2c3ebfdaec7b2537cb31ae663c1b204392fa91",
        "source_line": 16,
        "source_record_sha256": "266990803ed6a39347f1febb307bf94decace155f68e706f0f8b1c140ad47570"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 5,
        "arrears_amount": 235,
        "cash_shortfall_count": 1,
        "energy": 8,
        "hunger": 34,
        "loneliness": 3,
        "money": -20,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w16",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 17,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3456 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 98,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3456,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 74,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 42,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 67,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3221,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 66,
        "language": 100,
        "loneliness": 71,
        "money": 20,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 65,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 16
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 66.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "to": 100.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 66.0 to 100 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 2,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 2 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": -2,
        "energy": -8,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": -2,
        "visa_progress": 2
      },
      "event": {
        "id": "student_job_offer",
        "legal_choices": [
          {
            "choice_id": "student_job_offer.choice_01_去试工",
            "failure_effects": {
              "energy": -20.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": -20.0,
              "stress": 4.0,
              "work_hours": 8.0
            },
            "success_rate": 1.0,
            "text": "去试工"
          },
          {
            "choice_id": "student_job_offer.choice_02_婉拒",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "婉拒"
          },
          {
            "choice_id": "student_job_offer.choice_03_稳妥处理",
            "failure_effects": {
              "career_progress": 1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "career_progress": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.496,
            "text": "稳妥处理"
          },
          {
            "choice_id": "student_job_offer.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "career_progress": 2.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.609,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "student_job_offer.choice_02_婉拒"
      },
      "evidence": {
        "decision_request_fingerprint": "c4ac6cfcc0c30d50b2e296bfba287e8baa43e0fcf9764b3d0e16fd81c2b1f73d",
        "event_request_fingerprint": "62e5e091663597ddf7013ff29afa52306f878e9cfbb2794771eb8ab44c298615",
        "source_line": 17,
        "source_record_sha256": "9d35369ad15bba5c1959e3603f1a7258d50207110f0e21adadcd506b2357ca99"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -2,
        "blocked_account_balance": -992,
        "energy": -8,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": -2,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w17",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 18,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "压力 98。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 98,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 3456 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 96,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3456,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 77,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 43,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 69,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 98,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3456,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 74,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 42,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 67,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 17
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 66.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "to": 100.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 66.0 to 100 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 3,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 3 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": -3,
        "energy": -4,
        "exam_readiness": -3,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "stress": 2,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_week",
        "legal_choices": [
          {
            "choice_id": "exam_week.choice_01_先做会的题",
            "failure_effects": {
              "exam_readiness": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 5.0,
              "stress": 4.0
            },
            "success_rate": 0.432,
            "text": "先做会的题"
          },
          {
            "choice_id": "exam_week.choice_02_硬翻译题目",
            "failure_effects": {
              "exam_readiness": -4.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 2.0,
              "language": 3.0,
              "stress": 7.0
            },
            "success_rate": 0.592,
            "text": "硬翻译题目"
          },
          {
            "choice_id": "exam_week.choice_03_先扫整张卷子分配时间",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.005
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "stress": 2.0
            },
            "success_rate": 0.392,
            "text": "先扫整张卷子分配时间"
          },
          {
            "choice_id": "exam_week.choice_04_盯着第一题死磕",
            "failure_effects": {
              "exam_readiness": -8.0,
              "stress": 14.0
            },
            "next_event_id": "",
            "requirements": {
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -5.0,
              "stress": 10.0
            },
            "success_rate": 0.092,
            "text": "盯着第一题死磕"
          }
        ],
        "selected_choice_id": "exam_week.choice_01_先做会的题"
      },
      "evidence": {
        "decision_request_fingerprint": "00ec5e28bb797ca60461011759bb8346204deffc4559d847658bc71477f73cf3",
        "event_request_fingerprint": "efada293d6e7fcc82ebaab25eb4e27ad3c5bfa4d4f7dab6a741399e3025e5ce2",
        "source_line": 18,
        "source_record_sha256": "236bf52d544f4be45978861ab524e4671d85bb0ec627a86a999c300bd72674ce"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -3,
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "energy": -4,
        "exam_readiness": -3,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "stress": 2,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w18",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 19,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3594 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3594,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 97,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 80,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 44,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 71,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 96,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3456,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 77,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 43,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 69,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 18
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 30.0,
            "from": 65.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 95.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 65.0 to 95 in a single week (Δ=+30.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 66.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "to": 100.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 66.0 to 100 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 4,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 4 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise study priorities"
      },
      "delta": {
        "academic_progress": 2,
        "exam_readiness": 3,
        "loneliness": 3,
        "social": 3,
        "stress": -6,
        "visa_progress": 2
      },
      "event": {
        "id": "after_exam_void",
        "legal_choices": [
          {
            "choice_id": "after_exam_void.choice_01_休息半天",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 12.0,
              "stress": -10.0
            },
            "success_rate": 1.0,
            "text": "休息半天"
          },
          {
            "choice_id": "after_exam_void.choice_02_立刻复盘",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "立刻复盘"
          },
          {
            "choice_id": "after_exam_void.choice_03_稳妥处理",
            "failure_effects": {
              "academic_progress": 1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.578,
            "text": "稳妥处理"
          },
          {
            "choice_id": "after_exam_void.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 2.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.793,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "after_exam_void.choice_04_寻求帮助"
      },
      "evidence": {
        "decision_request_fingerprint": "b8803f89397f3ab7de208d3261937108da55f879b222e6e83461adb31d7d58b8",
        "event_request_fingerprint": "a4dea5429d9715a23551bd489706268f929b2eb8769c0247a44a93b1c4e5d39b",
        "source_line": 19,
        "source_record_sha256": "e5811d9267b41e809691d0f32e0c8c33bae77f9730e6342c4b7bff9404d1275c"
      },
      "finished": true,
      "full_numeric_delta": {
        "academic_progress": 2,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "exam_readiness": 3,
        "loneliness": 3,
        "social": 3,
        "stress": -6,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w19",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 20,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3849 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 94。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 94,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 95,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3849,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 83,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 47,
        "stress": 94,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 38,
        "visa_progress": 73,
        "week": 20,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3594,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 97,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 80,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 44,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 71,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 19
    }
  ],
  "persona": "study",
  "provider": "replay",
  "provider_mode": "replay",
  "provider_revision": "fixture:865f4fb83028f7ada18b581462adef3cbb15f2b06ed4c59cb0601f97b0d5f590",
  "scenario": "default_first_semester",
  "schema_version": "playthrough-view-v1",
  "seed": 42,
  "source_trace": {
    "artifact_path": "reports/playthrough-evidence/campaigns/playthrough-evidence-full-v1/cells/study-seed-42-f9980b3d5bc8/playthrough.jsonl",
    "artifact_sha256": "568b11027a1400d5c1683a2c4c31a96b49aaf93df744129b26c4c95e8638f6cd",
    "record_count": 19
  },
  "stop_reason": "game_finished",
  "truth_label": "prerecorded-real-godot-replay"
}
